import gql from 'graphql-tag';

const configQueries = {

    allSymbols: gql`
        query worktimesymbols {
            worktimesymbols(count: 9999, orderBy: [{ field: "acronym", order: ASC }]) {
                data {
                    id
                    acronym
                    name
                    record
                }
            }
        }
    `,

    symbol: gql`
        query worktimesymbol($id: ID) {
            worktimesymbol(id: $id) {
                data {
                    work_times {
                        id
                    }
                }
            }
        }
    `,

    deleteWorkTimeSymbol: gql`
        query deleteworktimesymbol($id: [ID!]!) {
            deleteworktimesymbol(id: $id) {
                id
            }
        }
    `,

};

export default configQueries;
